// extracted by mini-css-extract-plugin
export default {"like_list_wrapper":"LikeList_like_list_wrapper__7vfe4","like_list":"LikeList_like_list__78j3m"};